import type { GatsbyBrowser } from 'gatsby';
import './src/styles/global.css';
import { MATOMO_ENABLED } from './src/config/matomo';

/*
 * One page view per route, including the first — the head snippet
 * (gatsby-ssr.ts) configures the tracker but does not call trackPageView, so
 * the SPA navigation and the initial load are counted by the same code path.
 * `setCustomUrl` and `setReferrerUrl` are what gatsby-plugin-matomo pushes;
 * the title is read after a tick because Gatsby's Head updates it on the
 * next frame.
 */
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  if (!MATOMO_ENABLED || typeof window === 'undefined') return;
  const paq = ((window as any)._paq = (window as any)._paq || []);
  const url = location.href;
  const push = () => {
    if (prevLocation) paq.push(['setReferrerUrl', prevLocation.href]);
    paq.push(['setCustomUrl', url]);
    paq.push(['setDocumentTitle', document.title]);
    paq.push(['trackPageView']);
  };
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(() => setTimeout(push, 0));
  else setTimeout(push, 32);
};
